import { initReactI18next } from 'react-i18next'

import i18next from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import Backend from 'i18next-http-backend'

import { telemetryClient } from '~/lib/telemetry'
import authEN from '~/modules/auth/i18n/en.json'
import authES from '~/modules/auth/i18n/es.json'
import authPTBR from '~/modules/auth/i18n/pt-br.json'
import retailMediaEN from '~/modules/retailMedia/i18n/en.json'
import retailMediaES from '~/modules/retailMedia/i18n/es.json'
import retailMediaPTBR from '~/modules/retailMedia/i18n/pt-br.json'
import usersEN from '~/modules/users/i18n/en.json'
import usersES from '~/modules/users/i18n/es.json'
import usersPTBR from '~/modules/users/i18n/pt-br.json'
import configEN from '~/pages/configurations/i18n/en.json'
import configES from '~/pages/configurations/i18n/es.json'
import configPTBR from '~/pages/configurations/i18n/pt-br.json'

import commonEN from './locales/en.json'
import commonES from './locales/es.json'
import commonPTBR from './locales/pt-br.json'

export const defaultNS = 'rm'

i18next
  .use(Backend) // lazy loads translations from /public/locales
  .use(LanguageDetector) // detect user language
  .use(initReactI18next)
  .init({
    fallbackLng: 'pt-BR',
    debug: false,
    saveMissing: true,
    // No-op on purpose: without it, i18next's default missingKey handling calls
    // store.addResource for the missing key, which mutates the already-loaded
    // resource bundle in memory and can corrupt sibling keys (see PR #571).
    // We don't have a translation-management backend behind i18next-http-backend,
    // so there's nothing to save missing keys to — telemetry below (`missingKey`
    // event) already covers observability. Do not remove.
    missingKeyHandler: () => {},
    resources: {
      'pt-BR': {
        rm: retailMediaPTBR,
        auth: authPTBR,
        users: usersPTBR,
        common: commonPTBR,
        c: commonPTBR,
        config: configPTBR
      },
      en: {
        rm: retailMediaEN,
        auth: authEN,
        users: usersEN,
        common: commonEN,
        c: commonEN,
        config: configEN
      },
      'es-AR': {
        rm: retailMediaES,
        auth: authES,
        users: usersES,
        common: commonES,
        c: commonES,
        config: configES
      },
      'es-CO': {
        rm: retailMediaES,
        auth: authES,
        users: usersES,
        common: commonES,
        c: commonES,
        config: configES
      },
      es: {
        rm: retailMediaES,
        auth: authES,
        users: usersES,
        common: commonES,
        c: commonES,
        config: configES
      }
    },
    ns: ['common', 'c', 'rm', 'auth', 'users', 'config'],
    defaultNS,
    interpolation: {
      escapeValue: false,
      format: function (
        value: string,
        format: 'uppercase' | 'lowercase' | 'capitalize'
      ) {
        if (!value) return value

        switch (format) {
          case 'capitalize':
            return value.charAt(0).toUpperCase() + value.slice(1)
          case 'uppercase':
            return value.toUpperCase()
          case 'lowercase':
            return value.toLowerCase()
          default:
            return value
        }
      }
    }
  })

i18next.on('languageChanged', () => {
  window.location.reload()
})

i18next.on('missingKey', (lngs, ns, key, fallbackValue) => {
  const message = `[i18n missingKey] ${key} ${lngs} ${ns} not found`
  const payload = { lngs, ns, key, fallbackValue }
  console.warn(message, payload)
  telemetryClient.logError({ message, body: JSON.stringify(payload) })
})

export default i18next
